<template>
  <div class="relative form-field-container">
    <div
      class="flex items-center form-field"
      :class="[error && 'error', classes.field]"
      @click="show = true"
      ref="field"
    >
      <span class="form-label-top">
        {{ label }}
      </span>

      <span v-if="!date" class="italic text-ricoma-gray-600">{{ placeholder }}</span>

      <span class="px-4 py-1 ml-10 rounded bg-ricoma-gray-200 hover:bg-ricoma-gray-300">
        {{ formattedDate }}
      </span>

      <span class="form-field-icon left"><VSvgIcon name="calendar" /></span>
    </div>

    <div
      v-show="show"
      class="absolute top-0 left-0 right-0 z-50 w-full -mx-1 -mt-4 overflow-hidden bg-white rounded animation-scalingLeft animation-1/10s animation-ease-out animation-once"
      :style="{ width: '102%', boxShadow: '-1px 3px 7px 2px rgba(0, 0, 0, 0.2)' }"
      ref="datePicker"
    >
      <DatePicker
        v-model="date"
        is-inline
        is-expanded
        nav-visibility="hidden"
        :columns="1"
        class="form-datepicker"
      />
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'VFormDatePicker',
  components: { DatePicker, VSvgIcon },
  props: {
    label: {
      type: String,
      required: false,
      default: 'Select Date',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select a Date',
    },
    error: {
      type: String,
      required: false,
    },
    classes: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      date: new Date(),
      show: false,
    };
  },
  watch: {
    date(d) {
      this.show = false;
      this.$emit('pick', d);
    },
  },
  computed: {
    formattedDate() {
      return format(this.date, 'MMM do, yyyy');
    },
  },
  methods: {
    handleClickOutside(e) {
      const fieldElement = this.$refs.field;
      const datePickerElement = this.$refs.datePicker;

      // don't close modal when clicking on date picker
      if (datePickerElement === e.target || datePickerElement.contains(e.target)) return;

      if (!(fieldElement === e.target || fieldElement.contains(e.target))) {
        this.show && (this.show = false);
      }
    },
  },
  mounted() {
    // we need to make the state available upon mounting the component
    this.$emit('pick', this.date);

    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
